export default [
    {id: 1, collection: 'minersAndEquipment', power: 3, color: 'amber', icons: [
        {"x": 0, "y": -0.7, "rotate": 0, "size": 1.6, "icon": "mdi-hard-hat"},
        {"x": -0.55, "y": 0.35, "rotate": -20, "size": 2.5, "icon": "mdi-torch"},
        {"x": 0.45, "y": 0.35, "rotate": -30, "size": 2, "icon": "mdi-pickaxe"}
    ]},
    {id: 2, collection: 'minersAndEquipment', power: 2, reward: [
        {name: 'miningPickaxeCraftingQuality', type: 'mult', value: 1.5}
    ], color: 'brown', icons: [
        {"x": -0.3, "y": 0.05, "rotate": 0, "size": 1, "icon": "mdi-archive"},
        {"x": -0.55, "y": 0.5, "rotate": 0, "size": 1, "icon": "mdi-archive"},
        {"x": -0.05, "y": 0.5, "rotate": 0, "size": 1, "icon": "mdi-archive"},
        {"x": 0.45, "y": 0.15, "rotate": 90, "size": 2.25, "icon": "mdi-pickaxe"}
    ]},
    {id: 3, collection: 'minersAndEquipment', power: 2, reward: [
        {name: 'miningPickaxeCraftingSlots', type: 'base', value: 1}
    ], color: 'pale-blue', icons: [
        {"x": -0.25, "y": -0.35, "rotate": -50, "size": 1.75, "icon": "mdi-pickaxe"},
        {"x": 0.2, "y": -0.1, "rotate": -20, "size": 1.75, "icon": "mdi-pickaxe"},
        {"x": 0, "y": 0.25, "rotate": 0, "size": 2, "icon": "mdi-package"}
    ]},
    {id: 4, collection: 'minersAndEquipment', power: 2, reward: [
        {name: 'miningToughness', type: 'mult', value: 0.8}
    ], color: 'orange-red', icons: [
        {"x": -0.55, "y": 0, "rotate": 0, "size": 1.75, "icon": "mdi-bomb"},
        {"x": 0.4, "y": 0.15, "rotate": -35, "size": 2.5, "icon": "mdi-torch"}
    ]},
    {id: 5, collection: 'minersAndEquipment', power: 2, reward: [
        {name: 'currencyMiningScrapGain', type: 'mult', value: 1.2}
    ], color: 'pale-green', icons: [
        {"x": 0, "y": 0, "rotate": 0, "size": 4, "icon": "mdi-elevator-down"},
        {"x": -0.25, "y": 0.65, "rotate": 0, "size": 1, "icon": "mdi-account-hard-hat"},
        {"x": 0.2, "y": 0.6, "rotate": 0, "size": 1.1, "icon": "mdi-account-hard-hat"}
    ]},
    {id: 6, collection: 'minersAndEquipment', power: 2, reward: [
        {name: 'miningOreGain', type: 'mult', value: 1.2}
    ], color: 'orange', icons: [
        {"x": 0, "y": 0, "rotate": 0, "size": 4, "icon": "mdi-cupboard"},
        {"x": -0.25, "y": -0.6, "rotate": 0, "size": 0.8, "icon": "mdi-hard-hat"},
        {"x": 0.25, "y": -0.6, "rotate": 0, "size": 0.8, "icon": "mdi-hard-hat"},
        {"x": -0.1, "y": -0.1, "rotate": 0, "size": 0.8, "icon": "mdi-hard-hat"}
    ]},
    {id: 7, collection: 'minersAndEquipment', power: 1, reward: [
        {name: 'miningToughness', type: 'mult', value: 1 / 1.5}
    ], color: 'red', icons: [
        {"x": -0.35, "y": 0.1, "rotate": -95, "size": 1.5, "icon": "mdi-bomb"},
        {"x": 0.35, "y": 0, "rotate": 30, "size": 1.5, "icon": "mdi-bomb"},
        {"x": -0.05, "y": -0.45, "rotate": -15, "size": 1.5, "icon": "mdi-bomb"},
        {"x": 0, "y": 0.9, "rotate": 0, "size": 2, "icon": "mdi-sign-caution"}
    ]},
    {id: 8, collection: 'minersAndEquipment', power: 2, reward: [
        {name: 'miningDamage', type: 'mult', value: 1.15}
    ], color: 'purple', icons: [
        {"x": 0.85, "y": 0.5, "rotate": 0, "size": 2, "icon": "mdi-human-greeting"},
        {"x": 0.25, "y": -0.2, "rotate": -90, "size": 1.25, "icon": "mdi-pickaxe"},
        {"x": -0.8, "y": 0.8, "rotate": -20, "size": 2, "icon": "mdi-chart-bubble"},
        {"x": 0, "y": 0.9, "rotate": 220, "size": 1.8, "icon": "mdi-chart-bubble"},
        {"x": -0.35, "y": 0.3, "rotate": 0, "size": 1.6, "icon": "mdi-chart-bubble"}
    ]},
    {id: 9, collection: 'minersAndEquipment', power: 1, reward: [
        {name: 'currencyMiningScrapGain', type: 'mult', value: 1.35}
    ], color: 'teal', icons: [
        {"x": 0.6, "y": 0.3, "rotate": -10, "size": 2, "icon": "mdi-pickaxe"},
        {"x": -0.6, "y": 0.35, "rotate": 100, "size": 2, "icon": "mdi-shovel"},
        {"x": 0, "y": -0.5, "rotate": 0, "size": 1.5, "icon": "mdi-help"},
        {"x": 0.8, "y": -0.8, "rotate": 80, "size": 1.1, "icon": "mdi-chart-bubble"}
    ]},
    {id: 10, collection: 'minersAndEquipment', power: 2, reward: [
        {name: 'miningOreQuality', type: 'mult', value: 1.75}
    ], color: 'pink', icons: [
        {"x": -0.4, "y": 0.4, "rotate": 0, "size": 3, "icon": "mdi-cupboard"},
        {"x": -0.3, "y": -0.55, "rotate": 25, "size": 1.4, "icon": "mdi-pickaxe"},
        {"x": 0.7, "y": 0.65, "rotate": 0, "size": 2, "icon": "mdi-human-greeting"}
    ]},
    {id: 11, collection: 'minersAndEquipment', power: 1, reward: [
        {name: 'miningDamage', type: 'mult', value: 1.1},
        {name: 'currencyMiningOreAluminiumGain', type: 'mult', value: 1.6}
    ], color: 'pale-red', icons: [
        {"x": 0, "y": 0.5, "rotate": 0, "size": 3, "icon": "mdi-human-handsup"},
        {"x": -0.4, "y": -0.45, "rotate": -30, "size": 1.5, "icon": "mdi-pickaxe"},
        {"x": 0.35, "y": -0.55, "rotate": -60, "size": 1.5, "icon": "mdi-pickaxe"}
    ]},
    {id: 12, collection: 'minersAndEquipment', power: 1, reward: [
        {name: 'currencyMiningScrapGain', type: 'mult', value: 1.15},
        {name: 'currencyMiningOreCopperGain', type: 'mult', value: 1.6}
    ], color: 'light-blue', icons: [
        {"x": 0.4, "y": 0.5, "rotate": 0, "size": 2.5, "icon": "mdi-walk"},
        {"x": -0.8, "y": 1, "rotate": -125, "size": 0.8, "icon": "mdi-hard-hat"},
        {"x": 0.5, "y": -1, "rotate": 90, "size": 1, "icon": "mdi-motion"}
    ]},

    {id: 13, collection: 'scrapLogistics', power: 2, reward: [
        {name: 'currencyMiningScrapCap', type: 'mult', value: 1.4}
    ], color: 'beige', icons: [
        {"x": -1, "y": 0.65, "rotate": 0, "size": 1, "icon": "mdi-archive"},
        {"x": -0.5, "y": 0.65, "rotate": 0, "size": 1, "icon": "mdi-archive"},
        {"x": 0, "y": 0.65, "rotate": 0, "size": 1, "icon": "mdi-archive"},
        {"x": 0.5, "y": 0.65, "rotate": 0, "size": 1, "icon": "mdi-archive"},
        {"x": -0.75, "y": 0.2, "rotate": 0, "size": 1, "icon": "mdi-archive"},
        {"x": -0.25, "y": 0.2, "rotate": 0, "size": 1, "icon": "mdi-archive"},
        {"x": 0.25, "y": 0.2, "rotate": 0, "size": 1, "icon": "mdi-archive"},
        {"x": -0.5, "y": -0.25, "rotate": 0, "size": 1, "icon": "mdi-archive"},
        {"x": -0.5, "y": -0.7, "rotate": 0, "size": 1, "icon": "mdi-archive"},
        {"x": 1, "y": 0.65, "rotate": 0, "size": 1, "icon": "mdi-dots-triangle"},
        {"x": 0.1, "y": -0.1, "rotate": 0, "size": 1, "icon": "mdi-dots-horizontal"}
    ]},
    {id: 14, collection: 'scrapLogistics', power: 2, reward: [
        {name: 'currencyMiningScrapGain', type: 'mult', value: 1.12},
        {name: 'currencyMiningScrapCap', type: 'mult', value: 1.25}
    ], color: 'wooden', icons: [
        {"x": 0, "y": 0.4, "rotate": 0, "size": 2.5, "icon": "mdi-package"},
        {"x": 0, "y": -0.4, "rotate": 0, "size": 1.75, "icon": "mdi-dots-triangle"},
        {"x": 0.7, "y": 0.8, "rotate": 0, "size": 1.75, "icon": "mdi-circle-small"},
        {"x": -0.85, "y": 0.8, "rotate": 0, "size": 1.75, "icon": "mdi-circle-small"}
    ]},
    {id: 15, collection: 'scrapLogistics', power: 2, reward: [
        {name: 'currencyMiningOreAluminiumCap', type: 'base', value: 80},
        {name: 'currencyMiningOreCopperCap', type: 'base', value: 24}
    ], color: 'green', icons: [
        {"x": 0, "y": 0, "rotate": 0, "size": 4, "icon": "mdi-elevator-up"},
        {"x": -0.3, "y": 0.65, "rotate": 0, "size": 0.6, "icon": "mdi-archive"},
        {"x": 0, "y": 0.65, "rotate": 0, "size": 0.6, "icon": "mdi-archive"},
        {"x": 0.3, "y": 0.65, "rotate": 0, "size": 0.6, "icon": "mdi-package"},
        {"x": 0.3, "y": 0.45, "rotate": 0, "size": 0.5, "icon": "mdi-dots-triangle"}
    ]},
    {id: 16, collection: 'scrapLogistics', power: 1, reward: [
        {name: 'currencyMiningScrapGain', type: 'mult', value: 1.14},
        {name: 'currencyMiningOreAluminiumCap', type: 'mult', value: 2}
    ], color: 'pale-orange', icons: [
        {"x": 0.4, "y": 0, "rotate": 0, "size": 3, "icon": "mdi-excavator"},
        {"x": 0, "y": -0.1, "rotate": 0, "size": 1.75, "icon": "mdi-circle-small"},
        {"x": -0.8, "y": 0.4, "rotate": 0, "size": 1.75, "icon": "mdi-dots-triangle"}
    ]},
    {id: 17, collection: 'scrapLogistics', power: 1, reward: [
        {name: 'currencyMiningScrapCap', type: 'mult', value: 1.3},
        {name: 'currencyMiningOreCopperCap', type: 'mult', value: 2}
    ], color: 'lime', icons: [
        {"x": 0.5, "y": 0.5, "rotate": 0, "size": 2.5, "icon": "mdi-truck-flatbed"},
        {"x": 0.2, "y": 0.25, "rotate": 0, "size": 1.5, "icon": "mdi-dots-triangle"},
        {"x": -1, "y": 0.65, "rotate": 0, "size": 1.5, "icon": "mdi-dots-triangle"},
        {"x": -0.6, "y": 0.65, "rotate": -70, "size": 1.25, "icon": "mdi-shovel"}
    ]},
    {id: 18, collection: 'scrapLogistics', power: 2, reward: [
        {name: 'miningDamage', type: 'mult', value: 1.1},
        {name: 'currencyMiningScrapCap', type: 'mult', value: 1.2}
    ], color: 'skyblue', icons: [
        {"x": 0.6, "y": 0.35, "rotate": 0, "size": 2, "icon": "mdi-human-handsdown"},
        {"x": -0.7, "y": 0.5, "rotate": 0, "size": 1.6, "icon": "mdi-package"},
        {"x": -0.7, "y": 0, "rotate": 0, "size": 1.3, "icon": "mdi-dots-triangle"},
        {"x": 0.15, "y": 0.4, "rotate": -10, "size": 1, "icon": "mdi-clipboard-text"},
        {"x": 1, "y": 0.35, "rotate": -20, "size": 0.8, "icon": "mdi-pencil"}
    ]},
    {id: 19, collection: 'scrapLogistics', power: 3, reward: [
        {name: 'miningDepthDwellerSpeed', type: 'mult', value: 1.4}
    ], color: 'yellow', icons: [
        {"x": 0.5, "y": -0.1, "rotate": 0, "size": 2.5, "icon": "mdi-factory"},
        {"x": -0.6, "y": 0.75, "rotate": 0, "size": 1.75, "icon": "mdi-truck-flatbed"},
        {"x": -1, "y": 0.65, "rotate": 0, "size": 0.6, "icon": "mdi-archive"},
        {"x": -0.7, "y": 0.65, "rotate": 0, "size": 0.6, "icon": "mdi-archive"}
    ]},
    {id: 20, collection: 'scrapLogistics', power: 3, reward: [
        {name: 'currencyMiningCrystalGreenGain', type: 'mult', value: 1.15}
    ], color: 'grey', icons: [
        {"x": 0, "y": -1, "rotate": 0, "size": 1.5, "icon": "mdi-arrow-collapse-down"},
        {"x": 0, "y": 0.8, "rotate": 0, "size": 2, "icon": "mdi-square"},
        {"x": 0, "y": 0, "rotate": 0, "size": 1.5, "icon": "mdi-dots-triangle"}
    ]},
    {id: 21, collection: 'scrapLogistics', power: 2, reward: [
        {name: 'miningDepthDwellerSpeed', type: 'mult', value: 1.5},
        {name: 'currencyMiningCrystalGreenGain', type: 'mult', value: 1.2}
    ], color: 'red', icons: [
        {"x": 0, "y": 0, "rotate": 90, "size": 1.5, "icon": "mdi-dots-hexagon"},
        {"x": 0, "y": -0.9, "rotate": 180, "size": 1.25, "icon": "mdi-magnet-on"},
        {"x": 0, "y": 0.9, "rotate": 0, "size": 1.25, "icon": "mdi-magnet-on"},
        {"x": -0.65, "y": 0, "rotate": 0, "size": 1.5, "icon": "mdi-dots-horizontal"},
        {"x": 0.65, "y": 0, "rotate": 0, "size": 1.5, "icon": "mdi-dots-horizontal"}
    ]},
    {id: 22, collection: 'scrapLogistics', power: 3, reward: [
        {name: 'miningDamage', type: 'mult', value: 1.12}
    ], color: 'indigo', icons: [
        {"x": -0.5, "y": 0.1, "rotate": 0, "size": 2, "icon": "mdi-robot-industrial"},
        {"x": 0.7, "y": 0.25, "rotate": -20, "size": 1.5, "icon": "mdi-robot"},
        {"x": 0, "y": -0.2, "rotate": 0, "size": 1.5, "icon": "mdi-circle-small"}
    ]},

    {id: 23, collection: 'caveLocations', power: 3, reward: [
        {name: 'miningPickaxeCraftingQuality', type: 'mult', value: 1.25}
    ], color: 'light-blue', icons: [
        {"x": -0.15, "y": 0.2, "rotate": 90, "size": 1.8, "icon": "mdi-chart-bubble"},
        {"x": 0.15, "y": 0.3, "rotate": 225, "size": 2, "icon": "mdi-chart-bubble"},
        {"x": -0.1, "y": -0.3, "rotate": 80, "size": 1.25, "icon": "mdi-pickaxe"}
    ]},
    {id: 24, collection: 'caveLocations', power: 3, reward: [
        {name: 'miningPickaxeCraftingSlots', type: 'base', value: 1}
    ], color: 'pale-green', icons: [
        {"x": 0, "y": 0, "rotate": 0, "size": 2.75, "icon": "mdi-tunnel"},
        {"x": -0.7, "y": 0.9, "rotate": 0, "size": 1, "icon": "mdi-grass"},
        {"x": -1, "y": 0, "rotate": 0, "size": 0.75, "icon": "mdi-torch"},
        {"x": 1, "y": 0, "rotate": 0, "size": 0.75, "icon": "mdi-torch"}
    ]},
    {id: 25, collection: 'caveLocations', power: 2, reward: [
        {name: 'miningDepthDwellerSpeed', type: 'mult', value: 1.1},
        {name: 'currencyMiningOreTinCap', type: 'mult', value: 2}
    ], color: 'red', icons: [
        {"x": -0.65, "y": 0.5, "rotate": 0, "size": 1.6, "icon": "mdi-chart-bubble"},
        {"x": -0.35, "y": -0.1, "rotate": 60, "size": 1.8, "icon": "mdi-chart-bubble"},
        {"x": 0.65, "y": 0.5, "rotate": 120, "size": 2, "icon": "mdi-chart-bubble"},
        {"x": 0.35, "y": -0.1, "rotate": 180, "size": 2.2, "icon": "mdi-chart-bubble"},
        {"x": 0.1, "y": -0.6, "rotate": 240, "size": 2.4, "icon": "mdi-chart-bubble"},
        {"x": 0, "y": 1, "rotate": 0, "size": 1.25, "icon": "mdi-bomb"}
    ]},
    {id: 26, collection: 'caveLocations', power: 2, reward: [
        {name: 'miningPickaxeCraftingSlots', type: 'base', value: 1},
        {name: 'currencyMiningOreTinGain', type: 'mult', value: 1.6}
    ], color: 'yellow', icons: [
        {"x": -0.25, "y": -0.35, "rotate": 0, "size": 3, "icon": "mdi-minus"},
        {"x": 0.25, "y": -0.35, "rotate": 0, "size": 3, "icon": "mdi-minus"},
        {"x": -0.55, "y": 0.25, "rotate": 90, "size": 3, "icon": "mdi-minus"},
        {"x": 0.55, "y": 0.25, "rotate": 90, "size": 3, "icon": "mdi-minus"},
        {"x": -0.4, "y": 0.1, "rotate": 15, "size": 1, "icon": "mdi-torch"},
        {"x": 0.1, "y": -0.7, "rotate": 70, "size": 1.65, "icon": "mdi-chart-bubble"}
    ]},
    {id: 27, collection: 'caveLocations', power: 2, reward: [
        {name: 'miningDamage', type: 'mult', value: 1.2},
        {name: 'currencyMiningScrapGain', type: 'mult', value: 1.1}
    ], color: 'light-green', icons: [
        {"x": 0, "y": 0, "rotate": 225, "size": 2.25, "icon": "mdi-chart-bubble"},
        {"x": -0.65, "y": 0.7, "rotate": 0, "size": 1.55, "icon": "mdi-grass"},
        {"x": 0.5, "y": 0.45, "rotate": 0, "size": 1.25, "icon": "mdi-grass"},
        {"x": -0.55, "y": -0.4, "rotate": 0, "size": 1.15, "icon": "mdi-grass"},
        {"x": 0.85, "y": -0.6, "rotate": 0, "size": 1, "icon": "mdi-grass"},
        {"x": 0.15, "y": -0.85, "rotate": 0, "size": 0.9, "icon": "mdi-grass"}
    ]},
    {id: 28, collection: 'caveLocations', power: 3, reward: [
        {name: 'currencyMiningCrystalGreenGain', type: 'mult', value: 1.05},
        {name: 'currencyMiningOreIronCap', type: 'mult', value: 2}
    ], color: 'dark-grey', icons: [
        {"x": -0.5, "y": 0.85, "rotate": 5, "size": 2, "icon": "mdi-torch"},
        {"x": 0.95, "y": -0.9, "rotate": 65, "size": 1.5, "icon": "mdi-spider-web"},
        {"x": -0.85, "y": -0.45, "rotate": -15, "size": 1.2, "icon": "mdi-bat"},
        {"x": 0.05, "y": -0.9, "rotate": 10, "size": 1, "icon": "mdi-bat"},
        {"x": 0.6, "y": -0.1, "rotate": 30, "size": 1.1, "icon": "mdi-bat"},
        {"x": -0.2, "y": 0, "rotate": 5, "size": 1, "icon": "mdi-bat"},
        {"x": 0.5, "y": 0.65, "rotate": 45, "size": 1.4, "icon": "mdi-bat"}
    ]},
    {id: 29, collection: 'caveLocations', power: 3, reward: [
        {name: 'miningSmelterySpeed', type: 'mult', value: 1.15},
        {name: 'currencyMiningOreIronGain', type: 'mult', value: 1.6}
    ], color: 'light-grey', icons: [
        {"x": -0.65, "y": 0.9, "rotate": -20, "size": 2, "icon": "mdi-chart-bubble"},
        {"x": 0.9, "y": -0.95, "rotate": 20, "size": 1.5, "icon": "mdi-spider-web"},
        {"x": 0.1, "y": -1, "rotate": 40, "size": 1.2, "icon": "mdi-spider-web"},
        {"x": -1, "y": 0.3, "rotate": 15, "size": 1.1, "icon": "mdi-spider-web"},
        {"x": 0.1, "y": -0.1, "rotate": 0, "size": 1, "icon": "mdi-spider-thread"},
        {"x": 0.1, "y": -0.5, "rotate": 90, "size": 1, "icon": "mdi-minus"}
    ]},
    {id: 30, collection: 'caveLocations', power: 3, reward: [
        {name: 'miningOreGain', type: 'mult', value: 1.4}
    ], color: 'cyan', icons: [
        {"x": 0.4, "y": 0.6, "rotate": 30, "size": 2, "icon": "mdi-chart-bubble"},
        {"x": -0.25, "y": -0.2, "rotate": -10, "size": 2.2, "icon": "mdi-chart-bubble"},
        {"x": -0.6, "y": 0.75, "rotate": 75, "size": 2.4, "icon": "mdi-chart-bubble"},
        {"x": -0.3, "y": 0.35, "rotate": 10, "size": 0.75, "icon": "mdi-flare"}
    ]},
    {id: 31, collection: 'caveLocations', power: 5, color: 'dark-blue', icons: [
        {"x": 0, "y": 0.25, "rotate": 0, "size": 3, "icon": "mdi-ellipse-outline"},
        {"x": 0, "y": 0.25, "rotate": 0, "size": 1.5, "icon": "mdi-waves"},
        {"x": -0.9, "y": 0.9, "rotate": -20, "size": 1.5, "icon": "mdi-chart-bubble"},
        {"x": 0.2, "y": -0.75, "rotate": 75, "size": 1.2, "icon": "mdi-chart-bubble"},
        {"x": 0.9, "y": -0.45, "rotate": -135, "size": 1, "icon": "mdi-chart-bubble"}
    ]},

    {id: 32, collection: 'dangersInTheDark', power: 4, reward: [
        {name: 'miningSmelterySpeed', type: 'mult', value: 1.35}
    ], color: 'orange', icons: [
        {"x": -0.45, "y": 0.6, "rotate": -125, "size": 1.8, "icon": "mdi-liquid-spot"},
        {"x": 0.45, "y": 0.6, "rotate": 70, "size": 2, "icon": "mdi-liquid-spot"},
        {"x": 0, "y": 0.6, "rotate": 0, "size": 2.2, "icon": "mdi-liquid-spot"},
        {"x": 0, "y": -0.5, "rotate": 0, "size": 3, "icon": "mdi-fire"}
    ]},
    {id: 33, collection: 'dangersInTheDark', power: 4, reward: [
        {name: 'miningResinMax', type: 'base', value: 1},
        {name: 'currencyMiningOreTitaniumCap', type: 'mult', value: 2}
    ], color: 'cherry', icons: [
        {"x": -0.1, "y": 0.9, "rotate": 0, "size": 1, "icon": "mdi-skull"},
        {"x": 0.5, "y": 0.95, "rotate": 65, "size": 1, "icon": "mdi-skull"},
        {"x": 0.25, "y": 0.55, "rotate": 100, "size": 1, "icon": "mdi-skull"},
        {"x": -1, "y": 0.95, "rotate": -65, "size": 1, "icon": "mdi-skull"},
        {"x": -0.55, "y": 1, "rotate": 0, "size": 0.65, "icon": "mdi-bone"},
        {"x": -0.25, "y": 0.6, "rotate": -30, "size": 0.65, "icon": "mdi-bone"}
    ]},
    {id: 34, collection: 'dangersInTheDark', power: 4, reward: [
        {name: 'miningSmelterySpeed', type: 'mult', value: 1.1},
        {name: 'currencyMiningOreTitaniumGain', type: 'mult', value: 1.6}
    ], color: 'pale-purple', icons: [
        {"x": -0.25, "y": 0, "rotate": -135, "size": 2, "icon": "mdi-chart-bubble"},
        {"x": 0.4, "y": 0.7, "rotate": 75, "size": 2.25, "icon": "mdi-chart-bubble"},
        {"x": -0.5, "y": 0.7, "rotate": 0, "size": 1.5, "icon": "mdi-spider"}
    ]},
    {id: 35, collection: 'dangersInTheDark', power: 5, reward: [
        {name: 'miningResinMax', type: 'base', value: 1}
    ], color: 'brown', icons: [
        {"x": -1, "y": 0.75, "rotate": 0, "size": 1.5, "icon": "mdi-square"},
        {"x": 1, "y": 0.75, "rotate": 0, "size": 1.5, "icon": "mdi-square"},
        {"x": 0, "y": 0.3, "rotate": 0, "size": 2.5, "icon": "mdi-bridge"},
        {"x": 0, "y": 0.1, "rotate": 0, "size": 1.25, "icon": "mdi-circle"}
    ]},
    {id: 36, collection: 'dangersInTheDark', power: 4, reward: [
        {name: 'miningDamage', type: 'mult', value: 1.25},
        {name: 'miningResinMax', type: 'base', value: 1}
    ], color: 'blue-grey', icons: [
        {"x": 0, "y": 0.8, "rotate": 0, "size": 1.75, "icon": "mdi-human-handsdown"},
        {"x": -1, "y": -0.35, "rotate": 90, "size": 1, "icon": "mdi-motion"},
        {"x": 0.35, "y": -0.1, "rotate": 90, "size": 1.05, "icon": "mdi-motion"},
        {"x": 0.9, "y": -0.5, "rotate": 90, "size": 1.1, "icon": "mdi-motion"},
        {"x": -0.2, "y": -0.65, "rotate": 90, "size": 1.15, "icon": "mdi-motion"},
        {"x": -0.55, "y": 0.75, "rotate": 90, "size": 1.2, "icon": "mdi-motion"}
    ]},
    {id: 37, collection: 'dangersInTheDark', power: 5, reward: [
        {name: 'currencyMiningEmberGain', type: 'mult', value: 1.25}
    ], color: 'light-green', icons: [
        {"x": 0, "y": 1, "rotate": 90, "size": 3, "icon": "mdi-human-cane"},
        {"x": -0.6, "y": -0.3, "rotate": 0, "size": 1.2, "icon": "mdi-cloud"},
        {"x": 0.4, "y": -0.75, "rotate": 0, "size": 1.4, "icon": "mdi-cloud"},
        {"x": 0.7, "y": 0, "rotate": 0, "size": 1.6, "icon": "mdi-cloud"}
    ]},
    {id: 38, collection: 'dangersInTheDark', power: 4, reward: [
        {name: 'miningSmelterySpeed', type: 'mult', value: 1.25},
        {name: 'currencyMiningEmberGain', type: 'base', value: 0.1},
        {name: 'miningResinMax', type: 'base', value: 1}
    ], color: 'pale-pink', icons: [
        {"x": -0.85, "y": 0.8, "rotate": 90, "size": 3, "icon": "mdi-rectangle"},
        {"x": 0, "y": -0.05, "rotate": 20, "size": 1.75, "icon": "mdi-run-fast"},
        {"x": 0.45, "y": 0.8, "rotate": 150, "size": 1, "icon": "mdi-nail"},
        {"x": 0.6, "y": 0.7, "rotate": 170, "size": 1, "icon": "mdi-nail"},
        {"x": 0.8, "y": 0.7, "rotate": 190, "size": 1, "icon": "mdi-nail"},
        {"x": 0.7, "y": 1, "rotate": 0, "size": 1.25, "icon": "mdi-ellipse"}
    ]},
];
